import type { Vistory, VistoryStatus } from '@/features/vistories/types/vistory.types';

export interface VistoryGroups {
  draft: Vistory[];
  pending_approval: Vistory[];
  approved: Vistory[];
  rejected: Vistory[];
}

export interface StatusCounts {
  draft: number;
  pending_approval: number;
  approved: number;
  rejected: number;
}

const STATUS_ORDER: VistoryStatus[] = ['draft', 'pending_approval', 'approved', 'rejected'];

/**
 * Groups vistories by status and sorts within each group by created_at descending.
 */
export function groupVistoriesByStatus(vistories: Vistory[]): VistoryGroups {
  const groups: VistoryGroups = { draft: [], pending_approval: [], approved: [], rejected: [] };
  for (const v of vistories) {
    if (v.status in groups) {
      groups[v.status as keyof VistoryGroups].push(v);
    }
  }
  for (const key of STATUS_ORDER) {
    groups[key].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
  }
  return groups;
}

/**
 * Counts vistories per status.
 */
export function countByStatus(vistories: Vistory[]): StatusCounts {
  const counts: StatusCounts = { draft: 0, pending_approval: 0, approved: 0, rejected: 0 };
  for (const v of vistories) {
    if (v.status in counts) {
      counts[v.status as keyof StatusCounts]++;
    }
  }
  return counts;
}
